<template>
  <li class="flex flex-1 items-start gap-12">
    <div
      class="bg-static-brand-low rounded-md flex h-40 w-40 shrink-0 items-center justify-center"
    >
      <component :is="icon" size="20" />
    </div>

    <div class="flex flex-col">
      <p class="body-2-bold">{{ title }}</p>
      <p class="caption text-static-default-low">{{ description }}</p>
    </div>
  </li>
</template>

<script setup lang="ts">
import type { Component } from 'vue'

defineProps<{
  icon: Component
  title: string
  description: string
}>()
</script>
